<template>
  <div>
    <app-header></app-header>
    <div class="container-fluid user-last-login-report">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <app-admin-sidebar></app-admin-sidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <div :style="{ margin: '80px' }">
              <div class="card">
                <div class="card-header">
                  <b>User Last Login Report</b>
                </div>
                <div class="card-body">
                  <form @submit.prevent="fetchLastLoginReport">
                    <div class="row">
                      <div class="col">
                        <b>Client:</b>
                        <select class="form-control" id="client-dropdown" v-model="clientId">
                          <option value="">Select Client</option>
                          <option v-for="client in allClients" :key="client.clientId" :value="client.clientId.toString()">
                            {{ client.clientName }}
                          </option>
                        </select>
                      </div>
                      <div class="col">
                        <b>Start Date:</b>
                        <input type="date" class="form-control" v-model="startDate" placeholder="Start Date" />
                      </div>
                      <div class="col">
                        <b>End Date:</b>
                        <input type="date" class="form-control" v-model="endDate" placeholder="End Date" />
                      </div>
                    </div>
                    <div class="row pt-3 text-center">
                      <div class="col">
                        <button class="btn btn-primary" type="submit" :disabled="isSubmitting">
                          Export
                          <span v-if="isSubmitting">
                            <i class="fa fa-spinner fa-spin"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import DashboardService from "@/services/DashboardService";

export default {
  name: "UserLastLoginReport",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar
  },
  data() {
    return {
      clientId: "",
      startDate: "",
      endDate: "",
      allClients: [],
      isSubmitting: false,
      lastLoginReport: [],
      reportFetched: false,
    };
  },
  methods: {
    async getAllClients() {
      try {
        const response = await DashboardService.getAllClients();
        if (response.status === 200) {
          this.allClients = response.data;
        } else {
          alert(response.data.error || "Failed to fetch clients");
        }
      } catch (error) {
        alert(error.response?.data?.message || "Error fetching clients");
      }
    },
    exportToCSV(data, filename = 'last_login_report.csv') {
      if (!data.length) return;

      const headers = Object.keys(data[0]);
      const csvRows = [
        headers.join(","),
        ...data.map(row =>
          headers.map(header => {
            const value = row[header];
            return `"${(value ?? "").toString().replace(/"/g, '""')}"`;
          }).join(",")
        )
      ];

      const csvContent = csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async fetchLastLoginReport() {
      if (!this.clientId || !this.startDate || !this.endDate) {
        alert("Please fill all the fields before exporting.");
        return;
      }

      this.isSubmitting = true;
      try {
        const data = {
          client_id: this.clientId,
          start_date: this.startDate,
          end_date: this.endDate,
        };

        const response = await DashboardService.lastLoginReport(data);
        if (response.status === 200) {
          const reportData = response.data || [];
          if (reportData.length === 0) {
            alert("No data found for the selected criteria.");
            return;
          }

          const clientObj = this.allClients.find(c => c.clientId.toString() === this.clientId);
          const clientName = clientObj?.clientName?.replace(/\s+/g, '_') || "unknown_client";
          const filename = `last_login_report_${clientName}.csv`;

          this.exportToCSV(reportData, filename);
        } else {
          alert(response.data.error || "Failed to fetch last login report");
        }
      } catch (error) {
        alert(error.response?.data?.message || "Error fetching last login report");
      } finally {
        this.isSubmitting = false;
      }
    },

    formatDate(value) {
    if (!value) return "";
    const d = new Date(value);
    return d.toLocaleString(); // Customize as per your desired format
  }
},
mounted() {
  this.getAllClients();
  // Initialize select2 similar to your original component
  $('#client-dropdown').select2({
    placeholder: "Select Client",
    theme: "classic",
    width: '100%',
  }).on('change', (e) => {
    this.clientId = e.target.value;
  });
}
};
</script>

<style scoped lang="scss">
.user-last-login-report {
  min-height: 100%;
  margin: -14px 0 0 0;

  .card-header b {
    font-size: 1.25rem;
  }
}

html,
body {
  height: 100%;
}
</style>
